import { render } from "./AddPlatformModal.vue?vue&type=template&id=57ece377&scoped=true"
import script from "./AddPlatformModal.vue?vue&type=script&lang=js"
export * from "./AddPlatformModal.vue?vue&type=script&lang=js"

import "./AddPlatformModal.vue?vue&type=style&index=0&id=57ece377&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ece377"]])

export default __exports__